//Created by wangshuyi on 07/03/2018.

'use strict';
const panda = {
  name: 'dol-icon-panda',
  template: `<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
      <path d="M99.096 315.634s-82.58-64.032-82.58-132.13c0-66.064 33.032-165.162 148.646-148.646 83.37 11.91 99.096 165.162 99.096 165.162l-165.162 115.614zM924.906 315.634s82.58-64.032 82.58-132.13c0-66.064-33.032-165.162-148.646-148.646-83.37 11.91-99.096 165.162-99.096 165.162l165.162 115.614z" fill="#6B676E" p-id="1143" />
      <path d="M1024 561.548c0 264.526-229.23 429.42-512.002 429.42S0 826.076 0 561.548 283.96 66.064 512.002 66.064 1024 297.022 1024 561.548z" fill="#FFEBD2" p-id="1144" />
      <path d="M330.324 842.126c0 82.096 81.34 148.646 181.678 148.646s181.678-66.55 181.678-148.646H330.324z" fill="#E9D7C3" p-id="1145" />
      <path d="M644.13 611.098C594.582 528.516 561.55 512 512.002 512c-49.548 0-82.58 16.516-132.13 99.096-42.488 70.814-78.73 211.264-49.548 247.742 66.064 82.58 165.162 33.032 181.678 33.032 16.516 0 115.614 49.548 181.678-33.032 29.18-36.476-7.064-176.93-49.55-247.74z" fill="#FFFFFF" p-id="1146" />
      <path d="M611.098 495.484c0-45.608 36.974-82.58 82.58-82.58 49.548 0 198.194 99.098 198.194 165.162s-79.934 144.904-148.646 99.096c-49.548-33.032-132.128-148.646-132.128-181.678zM412.904 495.484c0-45.608-36.974-82.58-82.58-82.58-49.548 0-198.194 99.098-198.194 165.162s79.934 144.904 148.646 99.096c49.548-33.032 132.128-148.646 132.128-181.678z" fill="#6B676E" p-id="1147" />
      <path d="M512.002 726.622c-30.06 0-115.614 5.668-115.614 33.032 0 49.638 105.484 85.24 115.614 82.58 10.128 2.66 115.614-32.944 115.614-82.58-0.002-27.366-85.556-33.032-115.614-33.032z" fill="#464655" p-id="1148" />
      <path d="M330.324 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z" fill="#464655" p-id="1149" />
      <path d="M693.678 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z" fill="#464655" p-id="1150" />
    </svg>`
};
const right = {
  name: 'dol-icon-right',
  template: `<svg width="1em" height="1em" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="01-首页" transform="translate(-163.000000, -381.000000)" fill-rule="nonzero">
            <g id="箭头" transform="translate(187.000000, 405.000000) rotate(90.000000) translate(-187.000000, -405.000000) translate(163.000000, 381.000000)">
                <path stroke="currentColor" fill="currentColor" d="M33.6,19.2 C33.8916725,19.4885208 34.0558,19.8817353 34.0558,20.292 C34.0558,20.7022647 33.8916725,21.0954792 33.6,21.384 C33.3269959,21.6858597 32.9390018,21.8580932 32.532,21.8580932 C32.1249982,21.8580932 31.7370041,21.6858597 31.464,21.384 L25.992,15.984 L25.992,35.776 C26.0662026,36.3661368 25.7930324,36.9460685 25.2907783,37.264672 C24.7885241,37.5832755 24.1474759,37.5832755 23.6452217,37.264672 C23.1429676,36.9460685 22.8697974,36.3661368 22.944,35.776 L22.944,15.984 L17.472,21.6 C16.7669415,21.965873 15.9069497,21.8402562 15.336,21.288 C15.0443275,20.9994792 14.8802,20.6062647 14.8802,20.196 C14.8802,19.7857353 15.0443275,19.3925208 15.336,19.104 L22.968,11.304 C23.2765033,10.8517707 23.7885645,10.5812267 24.336,10.5812267 C24.8834355,10.5812267 25.3954967,10.8517707 25.704,11.304 L33.6,19.2 Z" id="路径"></path>
            </g>
        </g>
    </g>
</svg>`
};
const question = {
  name: 'dol-icon-question',
  template: `<svg width="1em" height="1em" viewBox="0 0 18 18" fill="none">
    <g opacity="1" transform="translate(0 0)  rotate(0)">
      <mask id="bg-mask-0" fill="white">
          <use transform="translate(0 0)  rotate(0)" xlink:href="#path_0"/>
      </mask>
      <g mask="url(#bg-mask-0)">
        <path id="路径 1" fill-rule="evenodd" style="fill:#333333" opacity="1" d="M8.99991,1.15967c4.31999,0 7.83999,3.52 7.83999,7.84c0,4.32003 -3.52,7.84003 -7.83999,7.84003c-4.32,0 -7.84,-3.52 -7.84,-7.84003c0,-4.32 3.52,-7.84 7.84,-7.84zM15.7199,8.99967c0,-3.7 -3.02,-6.71 -6.71999,-6.71c-3.7,0 -6.71,3.01 -6.71,6.71c0,3.70003 3.01,6.72003 6.71,6.72003c3.69999,0 6.71999,-3.02 6.71999,-6.72003z"/>
        <path id="路径 2" fill-rule="evenodd" style="fill:#333333" opacity="1" d="M6.53857 6.92584C6.53857 7.23584 6.78857 7.48584 7.09857 7.48584C7.40857 7.48584 7.66857 7.23584 7.66857 6.92584C7.66857 6.18584 8.24857 5.60584 8.99857 5.60584C9.73857 5.60584 10.3386 6.21584 10.3386 6.95584C10.3386 7.23584 9.93857 7.63584 9.57857 7.99584C9.04857 8.52584 8.43857 9.13584 8.43857 9.94584L8.43857 10.7558C8.43857 11.0658 8.68857 11.3158 8.99857 11.3158C9.30857 11.3158 9.55857 11.0658 9.55857 10.7558L9.55857 9.94584C9.55857 9.60584 9.97857 9.18584 10.3786 8.78584C10.8886 8.28584 11.4586 7.70584 11.4586 6.95584C11.4586 5.59584 10.3586 4.48584 8.99857 4.48584C7.63857 4.48584 6.53857 5.57584 6.53857 6.92584Z"/>
        <path id="路径 3" fill-rule="evenodd" style="fill:#333333" opacity="1" d="M8.99625 14.0987C9.46625 14.0987 9.84625 13.7187 9.84625 13.2487C9.84625 12.7887 9.46625 12.4087 8.99625 12.4087C8.53625 12.4087 8.15625 12.7887 8.15625 13.2487C8.15625 13.7187 8.53625 14.0987 8.99625 14.0987Z"/>
      </g>
    </g>
    <defs>
        <rect id="path_0" x="0" y="0" width="18" height="18"/>
    </defs>
</svg>`
};
const customer = {
  name: 'dol-icon-customer',
  template: `<svg width="1em" height="1em" viewBox="0 0 118 118" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="编组" fill-rule="nonzero">
            <path d="M58.6779546,88 C38.059324,88 21.3446213,71.2852973 21.3446213,50.6666666 C21.3446213,30.0480359 38.059324,13.3333333 58.6779546,13.3333333 C79.2965853,13.3333333 96.011288,30.0480359 96.011288,50.6666666 C96.011288,71.2852973 79.2965853,88 58.6779546,88 Z M58.6779546,72 C70.4646213,72 80.011288,63.0826666 80.011288,58.6666666 C80.011288,54.2506666 70.4646214,61.3333333 58.6779546,61.3333333 C46.8912879,61.3333333 37.3446213,54.2506666 37.3446213,58.6666666 C37.3446213,63.0826666 46.8912879,72 58.6779546,72 Z" id="形状" fill="currentColor"></path>
            <path d="M84.747288,99.0346666 C83.3081846,102.542393 79.6044618,104.558195 75.87743,103.862208 C72.1503982,103.166221 69.4237763,99.9496156 69.3475815,96.158922 C69.2713866,92.3682284 71.8665476,89.0446522 75.5626008,88.1994577 C79.2586541,87.3542632 83.0403898,89.2196035 84.619288,92.6666666 C96.5659546,83.8346666 104.011288,69.2853333 104.011288,53.3066666 C104.011288,26.7893333 83.6806213,5.33333325 58.6779546,5.33333325 C33.675288,5.33333325 13.3446213,26.7839999 13.3446213,53.312 C13.3433605,58.8056842 14.233135,64.2632077 15.979288,69.472 C16.3157389,70.3824157 16.1309605,71.4037419 15.496853,72.1385641 C14.8627455,72.8733863 13.8794589,73.2056479 12.9296059,73.0060605 C11.9797529,72.806473 11.2133516,72.1065592 10.9286213,71.1786666 C10.4203387,69.6767477 9.97725793,68.1535464 9.60062127,66.6133333 C4.35241083,66.0860978 0.27760494,61.8021136 0.0135374643,56.5341008 C-0.250530011,51.2660881 3.37544335,46.5960901 8.54462127,45.5466666 C12.1179546,19.808 33.1739546,7.10542736e-15 58.6779546,7.10542736e-15 C84.1819546,7.10542736e-15 105.237955,19.808 108.811288,45.5466666 C113.980779,46.5979669 117.605342,51.2702076 117.33858,56.5387658 C117.071817,61.807324 112.993862,66.0895638 107.744621,66.6133333 C104.448621,80.1279999 96.1979546,91.7973333 84.747288,99.0346666 Z" id="路径" fill="currentColor"></path>
        </g>
    </g>
</svg>`
};


export default {
  install(Vue) {
    Vue.component(panda.name, panda);
    Vue.component(right.name, right);
    Vue.component(question.name, question);
    Vue.component(customer.name, customer);

    Vue.prototype.$Dolphin({
      iconMap: { panda, right, question, customer },
    });

    Vue.prototype.$Dolphin.arrayToTree = function (array, {
      idField = 'id',
      parentField = 'parent',
      sortField = 'sort',
      childrenField = 'children',
      isLeafField = 'isLeaf',
      each
    } = {}) {
      array.sort((a, b) => a[sortField] > b[sortField] ? 1 : -1);

      let rootList = [], nodeMap = {};
      let once = (node) => {
        if (!nodeMap[node[idField]]) {
          node[childrenField] = [];
          nodeMap[node[idField]] = node;

          if (node[parentField]) {
            if (!nodeMap[node[parentField]]) {
              let parentNode = array.find(item => item[idField] === node[parentField]);
              if (parentNode) {
                once(parentNode);
              } else {
                rootList.push(node);
              }
            }

            if (nodeMap[node[parentField]]) {
              nodeMap[node[parentField]][childrenField].push(node);
            }
          } else {
            rootList.push(node);
          }

          if (typeof each === 'function') {
            each(node, nodeMap[node[parentField]]);
          }
        }
      };

      array.forEach(item => once(item));

      array.forEach(item => {
        item[isLeafField] = item[childrenField].length === 0;
      });

      return rootList;
    };
  }
};
